<template>
  <article class="min-h-page">
    <div class="flex justify-between items-center py-4 px-3 md:px-6">
      <div class="flex-auto">
        <h1 class="font-bold text-3xl" v-html="page.title.rendered"></h1>
      </div>
      <div>
        <router-link to="/">
          <close/>
        </router-link>
      </div>
    </div>
    <div class="py-4 px-3 md:px-6 p-max-w-xl">
      <div class="post-content mt-6">
        <div class="mb-6">
          <div v-html="page.content.rendered" class="mt-4"></div>
        </div>

        <div v-if="content.length">
          <div v-for="(row, i) in content" :key="i">
            <content-row :row="row" class="max-w-2xl"/>
          </div>
        </div>
      </div>
    </div>
  </article>
</template>

<script>
  import store from '@/store'
  import Close from '@/components/icons/Close'
  import ContentRow from '@/components/ContentRow'

  export default {
    name: 'Page',
    metaInfo () {
      return {
        title: this.title
      }
    },
    computed: {
      page () {
        return store.state.page
      },
      title () {
        if (!this.page) return ''
        return this.page.title.rendered
      },

      content () {
        if (!this.page) return []
        return this.page.acf?.content || []
      }
    },
    beforeRouteEnter (to, from, next) {
      let { slug } = to.params
      if (!slug) {
        slug = to.name
      }
      store.dispatch('getPageBySlug', slug).then(next)
    },
    beforeRouteUpdate (to, from, next) {
      let { slug } = to.params
      if (!slug) {
        slug = to.name
      }
      store.dispatch('getPageBySlug', slug).then(next)
    },
    components: { Close, ContentRow }
  }
</script>
